import {Injectable} from '@angular/core';

import {AuthenticationService} from "@shared/services/authentication/authentication.service";

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(
    private authenticationService: AuthenticationService
  ) {
  }

  hasEToll(): boolean {
    return this.authenticationService.hasModule("Module_eToll");
  }

  hasClientSelection(): boolean {
    return this.authenticationService.hasModule("AccessToAllClients");
  }

  hasDataSharing(): boolean {
    return this.authenticationService.hasUserRight("ShareLinks_Owner");
  }

  hasDataSharingAdmin(): boolean {
    return this.authenticationService.hasUserRight("ShareLinks_Admin");
  }

  hasAreasManagement(): boolean {
    return this.authenticationService.hasModule("Module_AreasManagement");
  }

  hasTrackAreasFormClientAreasMap(): boolean {
    return this.authenticationService.hasUserRight("TrackAreas_FormClientAreasMap");
  }

  hasVehicleRoutes(): boolean {
    return this.authenticationService.hasUserRight("GpsReports_RSLOT_PO");
  }

  //zakładka alarmy
  hasAlarms_RAZ_PO(): boolean {
    return this.authenticationService.hasUserRight("Alarms_RAZ_PO");
  }

  //zakładka paliwo w module alarmów
  hasStdReports_FUELALL_POL(): boolean {
    return this.authenticationService.hasUserRight("StdReports_FUELALL_POL");
  }

  //zakładka obszary w events
  hasStdReports_ROK_SP(): boolean {
    return this.authenticationService.hasUserRight("StdReports_ROK_SP");
  }

  hasCardFiles_FPersonals(): boolean {
    return this.authenticationService.hasUserRight("CardFiles_FPersonals");
  }

  hasCardFiles_FCardCars(): boolean {
    return this.authenticationService.hasUserRight("CardFiles_FCardCars");
  }

  hasStatus_FormStatusMap(): boolean {
    return this.authenticationService.hasUserRight("Status_FormStatusMap");
  }

  hasStatus_FormStatusTab(): boolean {
    return this.authenticationService.hasUserRight("Status_FormStatusTab");
  }

  hasHandover(): boolean {
    return this.authenticationService.hasModule('Module_Handovers') && this.authenticationService.hasUserRight("FleetMgr_FVehicleFleet");
  }

  hasBlockerRead(): boolean {
    return this.authenticationService.hasUserRight("IgnitionBlocker_Read");
  }

  hasBlockerReadWrite(): boolean {
    return this.authenticationService.hasUserRight("IgnitionBlocker_ReadWrite");
  }

  hasDriverTachoFiles(): boolean {
    return this.authenticationService.hasUserRight("Tacho_TACHO_DR");
  }

  hasVehicleTachoFiles(): boolean {
    return this.authenticationService.hasUserRight("Tacho_TACHO_1");
  }

  hasAnalisys_ASP_PO(): boolean {
    return this.authenticationService.hasUserRight("Analisys_ASP_PO");
  }

  hasModule_CheckDriverLicence(): boolean {
    return this.authenticationService.hasModule("Module_CheckDriverLicence");
  }

  hasCardFiles_FUsers(): boolean {
    return this.authenticationService.hasUserRight("CardFiles_FUsers");
  }

}
